export default {
  root: ({ props, attrs }) => ({
    class: [
      'flex',
      {
        'inline-flex': !!props.inline
      },
      'items-center align-top gap-2',
      'py-2 px-3 m-0 rounded-xs dark:border',
      'text-gray-900',
      {
        'bg-blue-200/70 dark:bg-blue-500/20':
          props.severity == 'info' || attrs['gb-theme'] === 'primary',
        'bg-green-100/70 dark:bg-green-500/20':
          props.severity == 'success' || attrs['gb-theme'] === 'green',
        'bg-orange-100/70 dark:bg-orange-500/20': props.severity == 'warn',
        'bg-red-100/70 dark:bg-red-500/20':
          props.severity == 'error' || attrs['gb-theme'] === 'red',
        'bg-gray-200': attrs['gb-theme'] === 'grayDark',
        'bg-white': attrs['gb-theme'] === 'grayLight'
      },
      {
        'dark:border-blue-400': props.severity == 'info',
        'dark:border-green-400': props.severity == 'success',
        'dark:border-orange-400': props.severity == 'warn',
        'dark:border-red-400': props.severity == 'error'
      }
    ]
  }),
  icon: ({ props, attrs }) => ({
    class: [
      {
        'text-base':
          props.severity !== 'info' &&
          props.severity !== 'success' &&
          props.severity !== 'error' &&
          attrs['gb-theme'] !== 'primary' &&
          attrs['gb-theme'] !== 'green' &&
          attrs['gb-theme'] !== 'red',
        'text-primary-400': props.severity === 'info' || attrs['gb-theme'] === 'primary',
        'text-green-300': props.severity === 'success' || attrs['gb-theme'] === 'green',
        'text-red-300': props.severity === 'error' || attrs['gb-theme'] === 'red'
      }
    ]
  }),
  text: {
    class: [
      // Font and Text
      'text-md',
      'font-normal'
    ]
  }
}
